import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logos/low-cost-framing-logo-svg-matched-4k.png" 
        alt="Low Cost Framing Logo"
        className="h-full object-contain"
        style={{ 
          maxHeight: size === 'sm' ? '64px' : size === 'md' ? '80px' : '96px',
          minHeight: size === 'sm' ? '56px' : size === 'md' ? '72px' : '88px',
          width: 'auto',
          maxWidth: 'none'
        }}
      />
    </div>
  );
};

export default Logo; 